/**
 * Which browser the page is running in, for features that behave differently
 * per platform (microphone help, saving photos on iPhone and iPad).
 */

export type BrowserKind =
  | "chrome"
  | "edge"
  | "firefox"
  | "safari"
  | "ios"
  | "other";

export function detectBrowser(
  userAgent: string,
  maxTouchPoints = 0,
): BrowserKind {
  // iOS first: every iOS browser is WebKit and takes its mic setting from the
  // system Settings app, whatever the UA says about Chrome or Firefox. iPad
  // Safari asks for desktop sites by default and so calls itself a Mac; a Mac
  // with a touch screen is the tell, as in useSetupAudioDevices.
  if (/iPad|iPhone|iPod/.test(userAgent)) return "ios";
  if (/Macintosh/.test(userAgent) && maxTouchPoints > 1) return "ios";
  if (/Edg\//.test(userAgent)) return "edge";
  if (/Firefox\//.test(userAgent)) return "firefox";
  if (/Chrome\/|CriOS\//.test(userAgent)) return "chrome";
  if (/Safari\//.test(userAgent)) return "safari";
  return "other";
}
